import { Modal } from 'cpool-components/general/Modal';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuCircleX, LuTrash2 } from 'react-icons/lu';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const DeleteCreditModal: React.FC<Props> = ({ onClose, onConfirm, open }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.DELETE_CONFIRM_TITLE')}
            panelClassName="max-w-[328px]"
        >
            <p className="text-sm text-midnight">{t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.DELETE_CONFIRM_TEXT')}</p>
            <div className="mt-4 flex justify-end gap-2">
                <Button variant={ButtonVariant.SECONDARY} iconLeft={<LuCircleX />} onClick={onClose}>
                    {t('BUTTONS.CANCEL')}
                </Button>
                <Button
                    iconLeft={<LuTrash2 />}
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                >
                    {t('BUTTONS.DELETE')}
                </Button>
            </div>
        </Modal>
    );
};
